import {
  Bell,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CheckCircle2,
  CheckSquare,
  ClipboardCheck,
  Clock3,
  FileText,
  FolderPlus,
  Megaphone,
  Settings,
  TriangleAlert,
  Unlock,
  User,
  UserCheck,
  XCircle
} from 'lucide-react';

// Utility function to get appropriate icons for different notification types
export const getNotificationIcon = (type) => {
  switch (type) {
    case 'evaluation':
      return ClipboardCheck;
    case 'worklog':
      return Clock3;
    case 'leaveRequest':
      return CalendarClock;
    case 'schedule':
      return Calendar;
    case 'announcement':
      return Megaphone;
    case 'reminder':
      return Bell;
    case 'approval':
      return CheckCircle2;
    case 'rejection':
      return XCircle;
    case 'assignment':
      return UserCheck;
    case 'completion':
      return CheckSquare;
    case 'overdue':
      return TriangleAlert;
    case 'eventReminder':
      return Calendar;
    case 'system':
      return Settings;
    case 'inServiceExam':
      return FileText;
    case 'eventInvitation':
      return CalendarPlus;
    case 'eventInvitationResponse':
      return CalendarCheck;
    case 'unlockRequest':
      return Unlock;
    case 'profile':
      return User;
    case 'onboardingAssignment':
      return FolderPlus;
    case 'onboardingSubmission':
      return FileText;
    case 'onboardingApproval':
      return CheckCircle2;
    case 'onboardingRejection':
      return XCircle;
    case 'onboardingOverdue':
      return TriangleAlert;
    default:
      return Bell;
  }
};

// Get notification icon color based on type
export const getNotificationIconColor = (type) => {
  switch (type) {
    case 'evaluation':
      return 'text-primary';
    case 'worklog':
      return 'text-success-dark';
    case 'leaveRequest':
      return 'text-info';
    case 'schedule':
      return 'text-warning';
    case 'announcement':
      return 'text-secondary';
    case 'reminder':
      return 'text-primary';
    case 'approval':
      return 'text-success-dark';
    case 'rejection':
      return 'text-danger';
    case 'assignment':
      return 'text-primary';
    case 'completion':
      return 'text-success-dark';
    case 'overdue':
      return 'text-danger';
    case 'eventReminder':
      return 'text-info';
    case 'system':
      return 'text-secondary';
    case 'inServiceExam':
      return 'text-warning';
    case 'eventInvitation':
      return 'text-info';
    case 'eventInvitationResponse':
      return 'text-success-dark';
    case 'unlockRequest':
      return 'text-warning';
    case 'profile':
      return 'text-primary';
    case 'onboardingAssignment':
      return 'text-primary';
    case 'onboardingSubmission':
      return 'text-info';
    case 'onboardingApproval':
      return 'text-success-dark';
    case 'onboardingRejection':
      return 'text-danger';
    case 'onboardingOverdue':
      return 'text-danger';
    default:
      return 'text-muted';
  }
};

// Get notification background color for icon container
export const getNotificationIconBg = (type) => {
  switch (type) {
    case 'evaluation':
      return 'bg-primary bg-opacity-10';
    case 'worklog':
      return 'bg-success';
    case 'leaveRequest':
      return 'bg-info bg-opacity-10';
    case 'schedule':
      return 'bg-warning bg-opacity-10';
    case 'announcement':
      return 'bg-secondary bg-opacity-10';
    case 'reminder':
      return 'bg-primary bg-opacity-10';
    case 'approval':
      return 'bg-success';
    case 'rejection':
      return 'bg-danger bg-opacity-10';
    case 'assignment':
      return 'bg-primary bg-opacity-10';
    case 'completion':
      return 'bg-success';
    case 'overdue':
      return 'bg-danger bg-opacity-10';
    case 'eventReminder':
      return 'bg-info bg-opacity-10';
    case 'system':
      return 'bg-secondary bg-opacity-10';
    case 'inServiceExam':
      return 'bg-warning bg-opacity-10';
    case 'eventInvitation':
      return 'bg-info bg-opacity-10';
    case 'eventInvitationResponse':
      return 'bg-success';
    case 'unlockRequest':
      return 'bg-warning bg-opacity-10';
    case 'profile':
      return 'bg-primary bg-opacity-10';
    case 'onboardingAssignment':
      return 'bg-primary bg-opacity-10';
    case 'onboardingSubmission':
      return 'bg-info bg-opacity-10';
    case 'onboardingApproval':
      return 'bg-success';
    case 'onboardingRejection':
      return 'bg-danger bg-opacity-10';
    case 'onboardingOverdue':
      return 'bg-danger bg-opacity-10';
    default:
      return 'bg-muted bg-opacity-10';
  }
};
